import React from "react"
import { Parallax } from "react-scroll-parallax"
import { Link } from "gatsby"
import LearnMoreIcon from "./LearnMoreIcon"

const Sections = ({
  img,
  imageTitle,
  children,
  reRouteLink,
  linkStyle,
  sectionTitle,
  title,
  orderStyle,
}) => {
  return (
    <div className="container">
      <div className="row align-center justify-content-between py-lg-4 my-lg-4">
        <div className="col-lg-5 position-relative">
          <Parallax y={[15, 0]}>
            <img
              data-aos="fade-up"
              data-aos-duration="2000"
              data-aos-anchor-placement="bottom-bottom"
              loading="lazy"
              src={img}
              className="img-fluid position-relative"
              alt={imageTitle}
              title={imageTitle}
            />
          </Parallax>
        </div>

        <div className={`col-lg-6 pt-lg-0 pt-5 ${orderStyle}`}>
          <p className="text-uppercase sparkle--mini sparkle-green">
            {sectionTitle}
          </p>
          <h4
            className="sparkle--title"
            data-aos="fade-up"
            data-aos-duration="2000"
          >
            {title}
          </h4>
          {children}
          <p
            className="sparkle--link mt-4"
            data-aos="fade-up"
            data-aos-duration="2000"
          >
            <Link to={reRouteLink} className={`${linkStyle}`}>
              Learn more{" "}
              <LearnMoreIcon/>
            </Link>
          </p>
        </div>
      </div>
    </div>
  )
}
export default Sections
